import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Participant = () => {


    const min = 1;
    const max = 100;

    // const [value, setValue] = useState(1);/

    const handleChange = event => {
        const value = Math.max(min, Math.min(max, Number(event.target.value)));
        // setValue(value);
        // setFormData('attend_time_percent', value)
        dispatch({type: 'setFormData', payload: {...formData, attend_time_percent : value}})

    };

    let formData = useSelector ((state) => state.event.formData)
    let dispatch = useDispatch()
    
    const setFormData = (type, value) => {
    }


    return (
        <>
        
        <div className="eform-item">
            <label htmlFor="eventName" className="elabel">Participants in the event</label>
            <div className="einput">
                <input
                    className="input eform-input"
                    type="text"
                    defaultValue={formData.participant_count}
                    onChange={(e) => { setFormData('participant_count', e.target.value) }}

                    name="participant"
                />
                <p className="einput-txt">You can limit the number of participants in the event as you wish. Considering technical indicators and performance, a maximum of 100 participants is recommended in a Metahut.</p>
            </div>
        </div>

        <div className="eform-item">
            <label htmlFor="eventName" className="elabel">Percentage of attend user a participant (%)</label>
            <div className="einput">
                <input
                    className="input eform-input"
                    type="number"
                    defaultValue={formData.attend_time_percent}
                    min={0}
                    max={100}
                    name="attend_time_percent"
                    value={formData.attend_time_percent}
                    onChange={handleChange}
                /> 
                {/* <p className="einput-txt">You can limit the number of participants in the event as you wish. Considering technical indicators and performance, a maximum of 100 participants is recommended in a Metahut.</p> */}
            </div>
        </div>
        </>
    )
    
}

export default Participant;